import React from 'react';
import {Modal} from 'react-bootstrap';
import {personFullName} from '../../../../services/Api/index';


const DeleteEventAttendanceModal = (props)=>{

    const { eventAttendance, onHide, onConfirm }= props;

    const person = props.person;

    return (
        <Modal
            show={true}
            onHide={onHide}>


            <Modal.Header closeButton>
                <Modal.Title>Eliminar asistencia a evento o taller</Modal.Title>
            </Modal.Header>

            <Modal.Body >

                <p>¿Estás seguro que deseas eliminar la asistencia a <strong>{eventAttendance.event.name}</strong> a <strong>{personFullName(person)}</strong> ?
                </p>
                <p>Esta acción no puede deshacerse.</p>

            </Modal.Body>

            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( eventAttendance ) }>Eliminar</button>
            </Modal.Footer>


        </Modal>
    );
};

export default DeleteEventAttendanceModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/DeleteEventAttendanceModal/index.jsx